import React from "react";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import BrandStory from "../components/BrandStory";
import Categories from "../components/Categories";
import ClothingTypes from "../components/ClothingTypes";
import FeaturedProducts from "../components/FeaturedProducts";
import Bestsellers from "../components/Bestsellers";
import Lookbook from "../components/Lookbook";
import NewArrivals from "../components/NewArrivals";
import ValueProps from "../components/ValueProps";
import Stats from "../components/Stats";
import Testimonials from "../components/Testimonials";
import Journal from "../components/Journal";
import FAQ from "../components/FAQ";

export function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <BrandStory />
      <Categories />
      <ClothingTypes />
      <FeaturedProducts />
      <Bestsellers />
      <Lookbook />
      <NewArrivals />
      <ValueProps />
      <Stats />
      <Testimonials />
      <Journal />
      <FAQ />
    </>
  );
}

export default Home;
